<template>
    <div class="row align-items-center px-2 py-3 shadow container-box">
        <div class="col-8" :class="{'col-12 text-center' : !getAccessDenied('btn', 'enable')}">
            <h5 class="mb-0 clean-text-css" v-if="getMsg">{{ getMsg }}</h5>
            <h5 class="mb-0 clean-text-css" v-else>{{$t('ct-restrict-area-not-have-permission')}}</h5>
        </div>
        <div class="col-4 text-right" v-if="getAccessDenied('btn', 'enable')">
            <a href="#" class="btn btn-sm btn-primary align-items-center justify-content-center d-inline-flex"
               v-if="getAccessDenied('btn', 'text')"
               @click.prevent="back">{{ getAccessDenied('btn', 'text') }}</a>
            <a href="#" class="btn btn-sm btn-primary align-items-center justify-content-center d-inline-flex" v-else
               @click.prevent="back">{{ $t('ct-home') }}</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NotHavePermission",

        computed: {
            getMsg() {
                let restrictArea = (typeof this.$parent.$parent.setLogin === 'function') ? this.$parent.$parent : this.$parent.$parent.$parent;
                return (restrictArea.form_theme.config && restrictArea.form_theme.config.access_denied && restrictArea.form_theme.config.access_denied.message) ? restrictArea.form_theme.config.access_denied.message : false;
            },
        },
        methods: {

            getAccessDenied(key, config) {
                let restrictArea = (typeof this.$parent.$parent.setLogin === 'function') ? this.$parent.$parent : this.$parent.$parent.$parent;

                if(config === 'enable'){
                    return (restrictArea.form_theme && restrictArea.form_theme.config && restrictArea.form_theme.config.access_denied &&
                        restrictArea.form_theme.config.access_denied[key] &&
                        typeof restrictArea.form_theme.config.access_denied[key][config] !== 'undefined') ? parseInt(restrictArea.form_theme.config.access_denied[key][config]) : (config === 'enable');
                }
                return (restrictArea.form_theme && restrictArea.form_theme.config && restrictArea.form_theme.config.access_denied &&
                    restrictArea.form_theme.config.access_denied[key] &&
                    typeof restrictArea.form_theme.config.access_denied[key][config] !== 'undefined') ? restrictArea.form_theme.config.access_denied[key][config] : (config === 'enable');

            },

            back() {
                this.$emit('back')
            },
        }
    }
</script>